const en = {
  app_name: "Netlen Canlı Destek",
  nav: {
    dashboard: "Dashboard",
    inbox: "Inbox",
    sites: "Sites",
    ai: "AI Chatbot",
    analytics: "Analytics",
    settings: "Settings",
    logout: "Logout",
  },
  auth: {
    login: "Sign In",
    register: "Sign Up",
    email: "Email",
    password: "Password",
    name: "Full Name",
    login_title: "Sign in to your account",
    register_title: "Create a new account",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    loading: "Loading...",
  },
  dashboard: {
    title: "Dashboard",
    welcome: "Welcome",
    total_convs: "Total Conversations",
    open_convs: "Open Conversations",
    ai_handled: "AI Resolved",
    resolved: "Resolved",
    recent_convs: "Recent Conversations",
    no_convs: "No conversations yet",
    view_all: "View All",
    today: "Today",
    this_week: "This Week",
  },
  inbox: {
    title: "Inbox",
    all: "All",
    open: "Open",
    pending: "Pending",
    resolved: "Resolved",
    unassigned: "Unassigned",
    mine: "Mine",
    search: "Search conversations...",
    no_convs: "No conversations found",
    type_message: "Type a message...",
    send: "Send",
    assign_to_me: "Assign to Me",
    resolve: "Resolve",
    close: "Close",
    reopen: "Reopen",
    visitor_info: "Visitor Info",
    quick_replies: "Quick Replies",
    add_note: "Add Note",
    internal_note: "Internal Note",
    tags: "Tags",
    pages_visited: "Pages Visited",
    no_pages: "No pages visited",
    ai_handled: "Handled by AI Chatbot",
    agent_handling: "Being handled by agent",
  },
  sites: {
    title: "Sites",
    add_site: "Add Site",
    domain: "Domain",
    name: "Site Name",
    embed_code: "Embed Code",
    copy_code: "Copy Code",
    copied: "Copied!",
    widget_settings: "Widget Settings",
    primary_color: "Primary Color",
    position: "Position",
    right: "Bottom Right",
    left: "Bottom Left",
    greeting: "Greeting Message",
    ai_settings: "AI Settings",
    enable_ai: "Enable AI Chatbot",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    no_sites: "No sites added yet",
    add_first: "Add your first site",
    agents: "Agents",
  },
  ai: {
    title: "AI Chatbot",
    knowledge_base: "Knowledge Base",
    add_text: "Add Text",
    add_url: "Add URL",
    upload_pdf: "Upload PDF",
    model: "AI Model",
    temperature: "Temperature",
    system_prompt: "System Prompt",
    enable: "Enable AI",
    save: "Save",
    no_kb: "No knowledge base items yet",
    delete: "Delete",
    title_field: "Title",
    content_field: "Content",
    url_field: "URL",
    training: "Training Data",
  },
  analytics: {
    title: "Analytics",
    period_7: "Last 7 Days",
    period_30: "Last 30 Days",
    period_90: "Last 90 Days",
    total: "Total Conversations",
    open: "Open",
    resolved: "Resolved",
    ai_rate: "AI Resolution Rate",
    resolution_rate: "Resolution Rate",
    agent_perf: "Agent Performance",
    daily_volume: "Daily Conversations",
    agent: "Agent",
    assigned: "Assigned",
    resolved_count: "Resolved",
    rate: "Rate",
    no_data: "No data for this period",
  },
  settings: {
    title: "Settings",
    profile: "Profile",
    canned: "Quick Replies",
    tags: "Tags",
    team: "Team",
    bans: "IP Bans",
    branding: "Brand Management",
    name: "Full Name",
    email: "Email",
    password: "New Password",
    save: "Save",
    add_canned: "Add Quick Reply",
    canned_title: "Title",
    canned_content: "Content",
    shortcut: "Shortcut",
    add_tag: "Add Tag",
    tag_name: "Tag Name",
    tag_color: "Color",
    delete: "Delete",
    select_site: "Select Site",
  },
  common: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    close: "Close",
    confirm: "Confirm",
    loading: "Loading...",
    error: "An error occurred",
    success: "Success",
    search: "Search...",
    no_data: "No data found",
    ago: "ago",
    just_now: "Just now",
    visitor: "Visitor",
    agent: "Agent",
    bot: "AI Bot",
  }
};

export default en;
